{
    "replacement": "[REDACTED]",
    "keys": [
        "accessToken",
        "access_token",
        "authorization",
        "body",
        "conferenceAlias",
        "conferenceName",
        "conference_alias",
        "conference_name",
        "cookie",
        "credential",
        "crypto",
        "displayName",
        "display_name",
        "fragment",
        "guestToken",
        "guest_token",
        "icePwd",
        "localAlias",
        "local_alias",
        "meetingId",
        "overlayText",
        "overlay_text",
        "password",
        "path",
        "pin",
        "query",
        "refreshToken",
        "refresh_token",
        "registrationToken",
        "registration_token",
        "secret",
        "ssoToken",
        "sso_token",
        "title",
        "token",
        "uri"
    ]
}
